module.exports = __webpack_public_path__ + "img/return-shipping.5f547368.png";